import { api } from '@/lib/api';
import type { IApiResponse, IJiraStatusChangeRow } from '@skystone/shared';

export const jiraStatusChangesApi = {
  getAll: async (): Promise<IJiraStatusChangeRow[]> => {
    const result = await api.get<IApiResponse<IJiraStatusChangeRow[]>>(
      '/admin/tbl/jira-status-changes',
    );
    return result.data;
  },
};
